var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 10.8333L12.375 15.1666L9 15.1666L13.5 20.5833L18 15.1666L14.625 15.1666L14.625 10.8333L12.375 10.8333Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 20.5833H10.125V18.4167H7.875C6.01425 18.4167 4.5 16.9585 4.5 15.1667C4.5 13.6457 5.84888 12.181 7.50713 11.9004L8.16075 11.7899L8.37675 11.1854C9.16763 8.96349 11.1319 7.58332 13.5 7.58332C16.6016 7.58332 19.125 10.0132 19.125 13V14.0833H20.25C21.4909 14.0833 22.5 15.0551 22.5 16.25C22.5 17.4449 21.4909 18.4167 20.25 18.4167H16.875V20.5833H20.25C22.7318 20.5833 24.75 18.6398 24.75 16.25C24.7483 15.2789 24.4087 14.3364 23.7855 13.5729C23.1623 12.8094 22.2915 12.269 21.312 12.038C20.8204 8.30916 17.505 5.41666 13.5 5.41666C10.3995 5.41666 7.70625 7.16191 6.47663 9.91249C4.06013 10.608 2.25 12.805 2.25 15.1667C2.25 18.1534 4.77338 20.5833 7.875 20.5833Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCloudDownload);
export default __webpack_public_path__ + "static/media/icons-cloud-download.8687216c1a5a085bc501ed5122c478c6.svg";
export { ForwardRef as ReactComponent };